export default "__VITE_ASSET__DMOnxmk4__"